import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle, TrendingUp } from "lucide-react";

interface BioWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onProceed: () => void;
  bioScore: number;
  feedback?: string;
}

export const BioWarningModal: React.FC<BioWarningModalProps> = ({
  isOpen,
  onClose,
  onProceed,
  bioScore,
  feedback
}) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className="fixed left-[50%] top-[50%] -translate-x-1/2 -translate-y-1/2 w-[calc(100%-2rem)] max-w-sm bg-gray-900 border border-gray-800 rounded-xl shadow-2xl">
        <AlertDialogHeader className="space-y-3">
          {/* Ícone + Score */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <AlertTriangle className="h-6 w-6 text-yellow-500" />
              <AlertDialogTitle className="text-lg font-semibold text-yellow-400">
                Bio Pode Melhorar
              </AlertDialogTitle>
            </div>
            <div className="px-3 py-1 rounded-full text-sm font-bold bg-yellow-500/20 text-yellow-400">
              {bioScore}/100
            </div>
          </div>

          {/* Feedback curto */}
          <AlertDialogDescription className="text-gray-300 text-sm">
            {feedback || 'Perfis com biografias completas têm 3x mais sucesso na plataforma.'}
          </AlertDialogDescription>

          {/* Benefícios de melhorar */}
          <div className="bg-emerald-500/10 border border-emerald-500/20 rounded-lg p-3 space-y-1">
            <div className="flex items-center gap-2 text-emerald-400 text-xs font-medium">
              <TrendingUp className="h-3 w-3" />
              <span>Melhorar biografia aumenta:</span>
            </div>
            <ul className="text-xs text-gray-400 space-y-0.5 ml-5">
              <li>• Visibilidade do perfil</li>
              <li>• Chances de conexões</li>
              <li>• Credibilidade</li>
            </ul>
          </div>
        </AlertDialogHeader>

        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel 
            onClick={onClose}
            className="w-full sm:w-auto bg-emerald-600 hover:bg-emerald-700 text-white border-0 font-medium"
          >
            Melhorar Agora
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={onProceed}
            className="w-full sm:w-auto bg-gray-700 hover:bg-gray-600 text-gray-200 font-medium"
          >
            Continuar Assim
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
